import { createFileRoute } from '@tanstack/react-router'

import { MessagingSettingsSection } from '@/features/organization/messaging-settings-section'

export const Route = createFileRoute('/_app/organizacao/mensagens')({
  component: MensagensTab,
})

function MensagensTab() {
  return <MessagingSettingsSection />
}
